/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import Cookies from 'universal-cookie';
export class GetUnbxdSearchAutoSuggestDataInput implements Msdyn365.IActionInput {
    public queryText?: string | undefined;
    public popularProducts?: number | undefined;
    public inFields?: number | undefined;
    public topQueries?: number | undefined;
    public keywordSuggestions?: number | undefined;
    public promotedSuggestion?: number | undefined;

    public getCacheKey = () => `Unbxd-autoSuggest-data-${this.queryText}`;
    public getCacheObjectType = () => 'Unbxd-autoSuggest-data';
    public dataCacheType = (): Msdyn365.CacheType => 'request';

    constructor(queryText?: string | undefined, popularProducts?: number | undefined, inFields?: number | undefined, topQueries?: number | undefined, keywordSuggestions?: number | undefined, promotedSuggestion?: number
        | undefined) {
        this.queryText = queryText;
        this.popularProducts = popularProducts;
        this.inFields = inFields;
        this.topQueries = topQueries;
        this.keywordSuggestions = keywordSuggestions;
        this.promotedSuggestion = promotedSuggestion;
    }
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getUnbxdSearchAutoSuggestData(input: GetUnbxdSearchAutoSuggestDataInput, ctx: Msdyn365.IActionContext): Promise<any> {
    const cookies = new Cookies();
    const unbxdUid = cookies.get('unbxd.userId');
    const queryText = input?.queryText ? input.queryText : "";
    const popularProductsCount = input?.popularProducts ? input.popularProducts : 0;
    const inFieldsCount = input?.inFields ? input.inFields : 0;
    const topQueriesCount = input?.topQueries ? input.topQueries : 0;
    const keywordSuggestionsCount = input?.keywordSuggestions ? input.keywordSuggestions : 0;
    const promotedSuggestionCount = input?.promotedSuggestion ? input.promotedSuggestion : 0;
    const unbxdApiKey = ctx.requestContext.app.config.unbxdApiKey;
    const unbxdSiteKey = ctx.requestContext.app.config.unbxdSiteKey;
    try {
        const unbxdUrl = `https://search.unbxd.io/${unbxdApiKey}/${unbxdSiteKey}/autosuggest?q=${queryText}&popularProducts.count=${popularProductsCount}&inFields.count=${inFieldsCount}&topQueries.count=${topQueriesCount}&keywordSuggestions.count=${keywordSuggestionsCount}&promotedSuggestion.count=${promotedSuggestionCount}&uid=${unbxdUid}`;
        const response = await Msdyn365.sendRequest<any>(unbxdUrl, 'get');
        if (response) {
            return response.data;
        }
        else { return null; }
    } catch (e) {
        return null;
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<{}>>getUnbxdSearchAutoSuggestData,
    id: 'getUnbxdSearchAutoSuggestData'
});
